import React from 'react';
import { BsCartPlus } from "react-icons/bs";

function AddToCartButton({ 
  onAddToCart, 
  isOutOfStock, 
  className = '', 
  disabled = false,
  children 
}) {
  const isDisabled = isOutOfStock || disabled;

  const handleClick = () => {
    if (!isDisabled && onAddToCart) {
      onAddToCart();
    }
  };

  return (
    <button 
      className={`add-to-cart-main ${isDisabled ? 'disabled' : ''} ${className}`}
      onClick={handleClick}
      disabled={isDisabled}
    >
      <BsCartPlus size={20} color='white'/>
      <span className='add-to-cart-text'>
        {children || (isOutOfStock ? 'Out of Stock' : 'Add to Cart')}
      </span>
      
    </button>
  );
}

export default AddToCartButton;
